<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>待审核-商品</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="名称/编码">
				<el-input v-model="item.name" placeholder="请输入商品名称或编码" size="small"></el-input>
			</el-form-item>

			<el-form-item label="商品分类">
				<el-cascader v-model="item.supplier_category_id"  placeholder="请选择"
					:options="optionsProduct" :props="{  value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true }" clearable></el-cascader>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['supplier/product/add']">添加商品</el-button>
		</div>

		<!--		:data="list"数据-->
		<el-table :data="list" border>
			<!--			这里 prop scope传值-->
			<!-- <el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column> -->
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="商品编码">
				<template slot-scope="scope">
					{{scope.row.sku_no}}
				</template>
			</el-table-column>
			<el-table-column label="商品图片">
				<!--				商品的组件和插槽-->
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="suppliercategory" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.suppliercategory">
					{{scope.row.suppliercategory.name}}
				</template>
			</el-table-column>
			<el-table-column label="状态">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_marketable">
						已上架
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						已下架
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="添加时间"></el-table-column>
			<el-table-column prop="last_modified_date" label="驳回时间"></el-table-column>

			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<!--					传ID过去修改-->
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['supplier/product/edit']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['supplier/product/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!--		页码-->
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'Menu',
		data() {
			return {
				// 商品数据
				list: [],
				isLoad: false,
				pageSize: 20,
				pageNum: 0,
				total: 0,
				page: 1,
				thumb: [],
				number: 0,
				item: {},
				optionsProduct: []
			}
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize,
					authStatus: 0,
				},
				this.getData()
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			getData() {
				// 获取商品分类
				this.axios.get('/supplier/data/getCategoryTreeSupplier', {}).then(res => {
					this.optionsProduct = res.data.tree
				})
			},
			changeCategory(data) {
				let len = data.length;
				if (len == 0) {
					// 清空数据
					this.item.supplier_category_id = '';
				} else {
					this.item.supplier_category_id = data[len - 1];
				}
			},
			add() {
				this.$router.push({
					path: '/Goods/add.html'
				});
			},
			// 获取数据
			loadList() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				//	将页码传到/Goods/index
				this.axios.post('/supplier/product/authListByPage', this.item)
					.then(res => {
						this.isLoad = !this.isLoad
						// 后端返回的商品数据列表
						this.list = res.data.list.data
						this.total = res.data.list.total

					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 商品审核
			edit(id) {
				this.$router.push({
					path: '/Goods/edit.html',
					query: {
						id: id
					}
				});
			},
			del(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				// ajax删除 先将要删除数据的ID传过去  执行删除
				this.axios.delete('/supplier/product/deleteOne', {
						data: {
							id: id
						}
					})
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						// 重新获取数据
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			//sizeReload 共多少条为一页
			sizeReload(val) {
				this.pageSize = val
				this.item = {
						page: this.page,
						limit: this.pageSize,
						authStatus: 1
				},
				this.getData()
				this.loadList()
			},
			// 前往第几页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			}
		}
	}
</script>
<style scoped>
</style>
